import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpSubscriptionsVipStudioPage() {
  const t = useTranslations('galleries_help.subscriptions_vip_studio');
  const [openSections, setOpenSections] = useState({
    overview: false,
    vipStudio: false,
    subscribersGet: false,
    studioOnly: false,
    preferredBuy: false,
    representedAccess: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('overview')}
            aria-expanded={openSections.overview}
          >
            <h2>{t('sections.overview.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.overview ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.overview && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.overview.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('vipStudio')}
            aria-expanded={openSections.vipStudio}
          >
            <h2>{t('sections.vip_studio.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.vipStudio ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.vipStudio && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.vip_studio.p1')}</p>
              <p>{t('sections.vip_studio.p2')}</p>
              <p>{t('sections.vip_studio.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('subscribersGet')}
            aria-expanded={openSections.subscribersGet}
          >
            <h2>{t('sections.subscribers_get.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.subscribersGet ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.subscribersGet && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.subscribers_get.p1')}</p>
              <p>{t('sections.subscribers_get.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('studioOnly')}
            aria-expanded={openSections.studioOnly}
          >
            <h2>{t('sections.studio_only.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.studioOnly ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.studioOnly && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.studio_only.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('preferredBuy')}
            aria-expanded={openSections.preferredBuy}
          >
            <h2>{t('sections.preferred_buy.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.preferredBuy ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.preferredBuy && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.preferred_buy.p1')}</p>
              <p>{t('sections.preferred_buy.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('representedAccess')}
            aria-expanded={openSections.representedAccess}
          >
            <h2>{t('sections.represented_access.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.representedAccess ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.representedAccess && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.represented_access.p1')}</p>
              <p>{t('sections.represented_access.p2')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
